import { render } from "./Index.vue?vue&type=template&id=75f0563c"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render

export default script